<!-- =========================================================================================
    File Name: GridView.vue
    Description: Display Dataset
    ----------------------------------------------------------------------------------------
      Author: Faruk Nikmorad
      Auth DATE: 11062020
========================================================================================== -->

<template>
 <div no-shadow card-border>
      <div v-if="isActiveOption || this.isActiveColumnFilter || this.isActiveSearch" class="flex flex-wrap items-center" style="height:60px">
        <div  class="flex-grow">
          <vs-button v-if="this.isActiveBtnNew" color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="HandleAction('New')">{{$t('New')}}</vs-button>
        </div>
        <div class="flex flex-wrap flex-row-reverse">
          <vs-dropdown v-if="this.isActiveOption" vs-trigger-click class="cursor-pointer">
            <feather-icon icon="SettingsIcon" class="cursor-pointer ml-4 mr-6 mt-1"  />
            <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>CSV</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown>
        <grid-columns-handler v-if="this.isActiveColumnFilter" :data="ColStatus" />
        <vs-input v-if="this.isActiveSearch" class="mb-4 md:mb-0 mr-4" v-model="searchQuery" placeholder="Search..." />
      </div>
    </div>

    <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      class="ag-grid-table ag-theme-balham my-4"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="usersData"
      :animateRows="true"
      :floatingFilter="FloatingFilter"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :getRowHeight="getRowHeight"
      @displayed-columns-changed="displayedColumnsChanged"
      @cellContextMenu="cellContextMenu">
    </ag-grid-vue>
    <div class="flex flex-wrap items-center">
      <div class="flex-grow">
        <vs-dropdown  vs-trigger-click class="cursor-pointer">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="gridApi.paginationSetPageSize(16)">
              <span>16</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(32)">
              <span>32</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(64)">
              <span>64</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div>
        <vs-pagination 
          :total="totalPages"
          :max="7"
          v-model="currentPage" />
      </div>
    </div>
  </div>
</template>


<script>
import { AgGridVue } from 'ag-grid-vue' //https://www.ag-grid.com/javascript-grid-column-moving/
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverrideBalham.scss'
// import 'ag-grid-community/src/styles/ag-theme-balham/sass/ag-theme-balham.scss'
// import 'ag-grid-community/src/styles/ag-theme-balham-dark/sass/ag-theme-balham-dark.scss'
// // import 'ag-grid-community/src/styles/ag-theme-base/sass/ag-theme-base.scss'
// import 'ag-grid-community/src/styles/ag-theme-blue/sass/ag-theme-blue.scss'
// import 'ag-grid-community/src/styles/ag-theme-bootstrap/sass/ag-theme-bootstrap.scss'
// // import 'ag-grid-community/src/styles/ag-theme-classic/sass/_ag-theme-classic.scss'
// import 'ag-grid-community/src/styles/ag-theme-dark/sass/ag-theme-dark.scss'
// import 'ag-grid-community/src/styles/ag-theme-fresh/sass/ag-theme-fresh.scss'

import genericCellRendererContent from './cell-renderer/genericCellRendererContent.vue'
import genericCellRendererButton from './cell-renderer/genericCellRendererButton.vue'

import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererCommunication from './cell-renderer/CellRendererCommunication.vue'
import CellRendererNameValue from './cell-renderer/CellRendererNameValue.vue'
import CellRendererGender from './cell-renderer/CellRendererGender.vue'
import CellRendererList from './cell-renderer/CellRendererList.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import GridColumnsHandler from '@/views/components/grid/GridColumnsHandler'
// import CellRendererLinkMt4 from './cell-renderer/CellRendererLinkMt4.vue'
import CellRendererContextMenu from './cell-renderer/CellRendererContextMenu.vue'
import CellRendererAccountActions from './cell-renderer/CellRendererAccountActions.vue'

// import cellRendererCurrency from './cell-renderer/cellRendererCurrency'
import cellRendererTransactionsType from './cell-renderer/transaction/cellRendererTransactionsType'
import cellRendererTransactionsStatus from './cell-renderer/transaction/cellRendererTransactionsStatus'
// import cellRendererAmount from './cell-renderer/cellRendererAmount'
// import cellRendererDateFormatter from './cell-renderer/cellRendererDateFormatter'
// import cellRendererAccountPassword from './cell-renderer/mt4/cellRendererAccountPassword'
// import cellRendererAccountLeverage from './cell-renderer/mt4/cellRendererAccountLeverage'
// import cellRendererAccountGroupTitle from './cell-renderer/mt4/cellRendererAccountGroupTitle'
// import cellRendererAccountRecharge from './cell-renderer/mt4/cellRendererAccountRecharge'
// import CellRendererIsActive from './cell-renderer/CellRendererIsActive.vue'
// import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'

// const cookie = require('js-cookie')
export default {

  props: {
    usersData: {
      type: Array,
      required: true
    },
    columnDefs: {
      type: Array,
      required: false
    },
    cookieName: {
      type: String,
      required: true
    },
    FloatingFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    isActiveSearch: {
      type: Boolean,
      required: false,
      default: true
    },
    isActiveColumnFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    isActiveOption: {
      type: Boolean,
      required: false,
      default: false
    },
    isAutoColumunDef: {
      type: Boolean,
      required: false,
      default: true
    },
    isActiveBtnNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AgGridVue,
    CellRendererLink,
    CellRendererStatus,
    CellRendererCommunication,
    CellRendererNameValue,
    CellRendererGender,
    CellRendererList,
    CellRendererActions,
    GridColumnsHandler,
    // CellRendererLinkMt4,
    CellRendererContextMenu,
    CellRendererAccountActions,
    // cellRendererCurrency,
    cellRendererTransactionsType,
    cellRendererTransactionsStatus,
    // cellRendererAmount,
    // cellRendererDateFormatter,
    // cellRendererAccountPassword,
    // cellRendererAccountLeverage,
    // cellRendererAccountGroupTitle,
    // cellRendererAccountRecharge,
    genericCellRendererContent,
    genericCellRendererButton

    // CellRendererVerified,
    // CellRendererIsActive,
  },
  data () {
    return {
      ColStatus: [],
      searchQuery: '',
      gridApi: null,
      gridColumnApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      components: {},
      WatchEnable: true,
      ColumnItem: {
        headerName: '',
        field: '',
        filter: true,
        width: 170,
        hide: false
      }
    }
  },
  computed:{
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 16
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    getCookieName () {
      if (this.cookieName !== null && this.cookieName !== '') return this.cookieName
      else return 'defaultColumnHandling'
    }
  },
  beforeMount () {
    this.getRowHeight = 50
    // params => {
    // // return 50 * (Math.max(params.data.emails.filter(f => f.isSelected).length, params.data.emails.filter(f => f.isSelected).length) ? Math.max(params.data.emails.filter(f => f.isSelected).length, params.data.emails.filter(f => f.isSelected).length) : 1);
    //   return 50 
    // }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  methods: {
    HandleAction (action) {
      this.$emit('onHandleActionClick', action)
    },
    EnterColumnDefs () {
      Object.keys(this.usersData[0]).forEach(itemKey => {
        this.ColumnItem.headerName = itemKey
        this.ColumnItem.field = itemKey
        this.ColumnItem.filter = true
        this.ColumnItem.width = 170
        this.ColumnItem.hide = false
        if (this.columnDefs.filter(f => f.field === this.ColumnItem.field).length === 0) {
          this.columnDefs.push({
            headerName: this.ColumnItem.headerName,
            field: this.ColumnItem.field,
            filter: this.ColumnItem.filter,
            width: this.ColumnItem.width,
            hide: this.ColumnItem.hide,
            cellRendererFramework: this.GetcellRendererFramework(this.ColumnItem.field)
          })
        }
      })
    },

    EnterColStatus () {
      let Res = null
      const cookieValue = localStorage.getItem(this.getCookieName)
      // const cookieValue = cookie.get(this.getCookieName)
      if (cookieValue && this.columnDefs.filter(arr => arr.headerName !== '').length === JSON.parse(cookieValue).length) {
      // if (cookieValue) {
        Res = JSON.parse(cookieValue)
      } else {
        Res = this.columnDefs.filter(arr => arr.headerName !== '').map(
          (arr) => { 
            return {
              name: arr.headerName,
              visible: !arr.hide,
              lock: arr.lockPosition || false
            }
          }
        )
      }
      this.WatchEnable = false
      for (const ColStatusItem of Res) {
        this.ColStatus.push({
          name:ColStatusItem.name,
          visible:ColStatusItem.visible,
          lock:ColStatusItem.lock})
      }

      this.WatchEnable = true
    },

    displayedColumnsChanged () {
      const tmpState = this.gridColumnApi.getColumnState()
      for (const v of tmpState) {
        if (this.gridColumnApi.getDisplayNameForColumn(this.gridColumnApi.getColumn(v.colId)) === '') continue

        const item = this.ColStatus.filter(f => f.name === this.gridColumnApi.getDisplayNameForColumn(this.gridColumnApi.getColumn(v.colId)))
        if (item.length === 0) {
          this.ColStatus.push(
            {
              name:     this.gridColumnApi.getDisplayNameForColumn(this.gridColumnApi.getColumn(v.colId)), 
              visible:  !v.hide,
              lock:     v.pinned
            })
        } else if (v.hide === item[0].visible) {
          item[0].visible = !v.hide
        }
      }
    },
    GetcellRendererFramework (fieldName) {
      switch (fieldName) {
      // case 'LEVERAGE':
      //   return 'CellRendererAccountEditLeverage'
      default:
        return null
        // return 'CellRendererContextMenu'
      }
    },
    cellContextMenu (params) {
      this.$emit('onCelContextMenu', params)
    }
  },

  created () {
    //if (!this.columnDefs || this.columnDefs.length === 0) 
    if (!this.columnDefs || this.columnDefs.length === 0 || this.isAutoColumunDef) this.EnterColumnDefs()
      
    if (this.ColStatus.length === 0) this.EnterColStatus()
  },
  watch:{
    ColStatus: {
      deep: true,
      handler () {
        if (this.WatchEnable) {
          localStorage.setItem(this.getCookieName, JSON.stringify(this.ColStatus))
          // cookie.set(this.getCookieName, JSON.stringify(this.ColStatus), { expires: 365 })
          if (!this.gridColumnApi) return
          const tmpState = this.gridColumnApi.getColumnState()
          for (const v of tmpState) {

            if (this.gridColumnApi.getDisplayNameForColumn(this.gridColumnApi.getColumn(v.colId)) === '') continue

            const item = this.ColStatus.filter(f => f.name === this.gridColumnApi.getDisplayNameForColumn(this.gridColumnApi.getColumn(v.colId)))
            if (item.length === 1 && tmpState[tmpState.indexOf(v)].hide === item[0].visible)        {
              tmpState[tmpState.indexOf(v)].hide = !item[0].visible
              this.gridColumnApi.setColumnState(tmpState)
            }
          }
        }
      }
    },
    searchQuery: {
      handler () {
        this.gridApi.setQuickFilter(this.searchQuery)
      }
    }
  }
}
import store from './../../../store/store'
window.getGroupTitle = function getGroupTitle (params) {
  return store.state.CustomManagment.groups.filter(f => f.mtGroupName === params.value).length ? store.state.CustomManagment.groups.filter(f => f.mtGroupName === params.value)[0].groupTitle : params.value
}
window.percentFormatter = function percentFormatter (params) {
  return `\x25 ${  formatNumber(params.value)}`
}

window.currencyFormatter = function currencyFormatter (params) {
  return formatNumber(params.value)
}

window.currencyFormatterWithDollar = function currencyFormatterWithDollar (params) {
  return `\x24 ${  formatNumber(params.value)}`
}
window.formatNumber = function formatNumber (number) {
  return number.toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
window.hideMobile = function hideMobile (params) {
  const number = params.value
  if (number === null || number === undefined || number.length <= 7) return number

  const index = number.length > 10 ? 10 - 5 : number.length - 5
  return `${number.toString().substring(0, index)  }***${  number.toString().substring(index + 3)}`
}
window.dateFormatter = function dateFormatter (params) {
  const d = new Date(params.value)

  const  datestring = `${ d.getFullYear() }-${  (`0${d.getMonth() + 1}`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }  
   ${  (`0${  d.getHours()}`).slice(-2)  }:${  (`0${  d.getMinutes()}`).slice(-2)}:${  (`0${  d.getSeconds()}`).slice(-2)}`

  return datestring
}
// Vue.prototype.currencyFormatter = window.currencyFormatter
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>